window.Theme = window.Theme || {};
Theme.Product = (() => {
  // let productSlider, productThumbSlider; // already declared globally in theme-scripts.liquid
  let currentVideo = null;

  const getMousePos = (e) => {
    var pos = e.currentTarget.getBoundingClientRect();
    return {
      x: e.clientX - pos.left,
      y: e.clientY - pos.top,
    };
  };

  function pauseMedia(container) {
    container.querySelectorAll('.yv-youtube-video').forEach(video =>
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    container.querySelectorAll('.yv-vimeo-video').forEach(video =>
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    );
    container.querySelectorAll('video').forEach(video => video.pause());
  }

 function initProductSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productSlider = new Flickity(sliderMain, options);
        setTimeout(() => productSlider.resize(), 300);
      }
    }

    if (productSlider) {
      productSlider.on('change', function () {
        pauseMedia(productSlider.element);
      });
    }
  }

  function initProductThumbSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    // The selected-color angle strip must remain centered even when markup
    // rendered by an older section response still says cellAlign: "left".
    if (sliderMain.closest('[data-tt-product-gallery]')) {
      options.cellAlign = 'center';
      options.contain = true;
      options.cellSelector = '.tt-color-visible';
    }

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider = new Flickity(sliderMain, options);
        setTimeout(() => productThumbSlider.resize(), 300);
      }
    }

    if (productThumbSlider) {
      productThumbSlider.on('change', function () {
        pauseMedia(productThumbSlider.element);
      });
    }
  }

  function findVisibleItems() {
    let mainSliderParent = document.getElementById('yv-product-gallery-slider');
    if (mainSliderParent) {
      let elements = mainSliderParent.getElementsByClassName('gallery-main-item');
      let thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');

      window.addEventListener('scroll', () => {
        Array.from(elements).forEach(item => {
          if (isOnScreen(item)) {
            let relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="' + item.id + '"]');
            if (relatedThumb) {
              Array.from(thumbs).forEach(thumb => thumb.classList.remove('active'));
              relatedThumb.classList.add('active');
            }
          }
        });
      });
    }
    let mainTabsContent =  document.getElementById('yvProductFeatureListwrapper');
    if(mainTabsContent){
      let contentTabs = document.getElementsByClassName('yv-product-feature');	
      window.addEventListener('scroll', function(event){     
        Array.from(contentTabs).forEach(function(item) {
          if (isOnScreen(item)) {
            let headTabs = document.getElementsByClassName('feature-link');
            Array.from(headTabs).forEach(function(head) {
              head.parentNode.classList.remove('active');
            });
            var relatedHead = document.querySelector('.feature-link[href="#'+item.id+'"]');
            if(relatedHead){
              relatedHead.parentNode.classList.add('active');
            }
          }
        });
      });
    }
  }

  function sizeChart() {
    let sizeChartInit = document.querySelectorAll('.sizeChart-label');
    let sizeChartModel = document.getElementById('sizeChartModel');
    if (sizeChartInit && sizeChartModel) {
      let sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');
      sizeChartInit.forEach(label => {
        label.addEventListener("click", e => {
          e.preventDefault();
          // $(sizeChartModel).fadeIn(100);
          document.body.classList.add('sizeChartOpen');
          sizeChartClose.focus();
        });
      });
      sizeChartClose.addEventListener("click", () => {
        document.body.classList.remove('sizeChartOpen');
        // $(sizeChartModel).fadeOut(100);
      });
    }
  }

  function initStickyAddToCart() {
    let mainProductForm = document.querySelector('.main-product-form');
    let stickyBar = document.getElementById('yvProductStickyBar');

    if (mainProductForm && stickyBar) {
      window.addEventListener('scroll', () => {
        if (isOnScreen(mainProductForm, true) || window.scrollY < mainProductForm.offsetTop) {
          stickyBar.classList.remove('show');
        } else {
          stickyBar.classList.add('show');
        }
      });
    }
  }

  function onReadyEvent() {
    setTimeout(function () {
      var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
      var lastKnownY = window.scrollY;
      var currentTop = 0;
      if (thumbnails) {
        var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top);
        window.addEventListener('scroll', function (event) {
          var bounds = thumbnails.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + initialTopOffset,
            minTop = thumbnails.clientHeight - window.innerHeight;
          if (window.scrollY < lastKnownY) {
            currentTop -= window.scrollY - lastKnownY;
          } else {
            currentTop += lastKnownY - window.scrollY;
          }
          currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
          lastKnownY = window.scrollY;
          thumbnails.style.top = "".concat(currentTop, "px");
        });
      }
    }, 1000);

    // jQuery('body').on('click', '.gallery-thumbs-item', function (e) {
    //   e.preventDefault();
    //   var destination = jQuery(this).attr('data-image');
    //   var top = jQuery('.shopify-section-main-header').height() + 10;
    //   if (jQuery('#' + destination + '.gallery-main-item').length > 0) {
    //     jQuery('html,body').animate({ scrollTop: (jQuery('#' + destination + '.gallery-main-item').offset().top) - top });
    //   }
    // });

    jQuery('body').on('click', '.pdp-view-close', function (e) {
      e.preventDefault();
      jQuery('#yvProductStickyBar').remove();
    });

    jQuery('body').on('click', '.feature-link', function (e) {
      e.preventDefault();
      let destination = jQuery(this).attr('href');
      let top = jQuery('.shopify-section-main-header').height() + 90;
      if (jQuery(destination).length > 0) {
        jQuery('html,body').animate({ scrollTop: (jQuery(destination).offset().top) - top });
      }
    });

    jQuery('body').on('change', '.sticky-bar-product-options', function () {
      let _section = jQuery(this).closest('.shopify-section');
      let option = jQuery(this).attr('data-name');
      let value = jQuery(this).val();
      let mainOption = _section.find('.productOption[name="' + option + '"]');
      if (mainOption.is(':radio')) {
        _section.find('.productOption[name="' + option + '"][value="' + CSS.escape(value) + '"]').attr('checked', true).trigger('click');
      } else {
        mainOption.val(value);
        let sectionId = document.querySelector('#' + _section.attr('id'));
        if (sectionId) {
          let optionSelector = document.querySelector('.productOption[name="' + option + '"]');
          if (optionSelector) {
            optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    if (typeof fancySelector !== 'undefined') {
      Fancybox.bind(fancySelector, {
        touch: false,
        thumbs: {
          autoStart: true
        },
        on: {
          load: () => pauseMedia(document),
          done: () => pauseMedia(document)
        },
        Toolbar: {
          display: ["close"]
        }
      });
    }
  }

  function productZoomInit() {
    $('.yv-product-zoom').mouseenter(function (e) {
      $('.yv-product-zoom').removeClass('show');
      if ($(window).width() > 1021) {
        $(this).addClass('show');
      }
    });
    $('.yv-product-zoom').mousemove(function (e) {
      if ($(window).width() > 1021) {
        let t = getMousePos(e);
        this.querySelector('.gallery-cursor').style.translate = `${t.x}px ${t.y}px`;
      }
    });
    $('.yv-product-zoom').mouseleave(function (e) {
      $('.yv-product-zoom').removeClass('show');
    });
  }

  function load3DModel() {
    if (!window.Shopify) return;

    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: () => {
          if (!window.ShopifyXR || typeof window.ShopifyXR.addModels !== 'function') {
            document.addEventListener('shopify_xr_initialized', () => {
              load3DModel();
            });
            return;
          }

          document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
            window.ShopifyXR.addModels(JSON.parse(model.textContent));
          });
          window.ShopifyXR.setupXRElements();
        }

      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: () => {
          document.querySelectorAll('.yv-product-model-item').forEach((model) => {
            let model3D = model.querySelector('model-viewer');
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.remove('hidden'));
              if (productSlider) {
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            });
            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.add('hidden'));
              if (productSlider) {
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            });
            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', () => model.modelViewerUI.pause());
            });
          });
        }
      }
    ]);
  }

  function onLoad(section = document) {
    initProductSlider(section);
    initProductThumbSlider(section);
if (typeof findVisibleItems === 'function') {
  findVisibleItems();
}
    productZoomInit();
    sizeChart();
    initStickyAddToCart();
    load3DModel();
    onReadyEvent();
  }

  $(document).ready(function () {
    onLoad(document);
    onReadyEvent();

    function playVideo() {
      currentVideo = $('[data-reel-content] video')[0];
      if (currentVideo) {
        currentVideo.load();
        currentVideo.play();
      }
    }

    function pauseVideo() {
      if (currentVideo) {
        currentVideo.pause();
      }
    }
  });

  return {
    initProductSlider,
    initProductThumbSlider
  };
})();

/*
 * Compatibility bridge for ProductInfo.updateMedia() in common.js.
 * common.js calls these global names after it destroys a product gallery.
 * The actual initializers live under Theme.Product, so without this bridge
 * the gallery remains as uninitialized HTML until another delayed update.
 */
window.initProductSlider = function(section = document) {
  return Theme.Product.initProductSlider(section);
};

window.initProductThumbSlider = function(section = document) {
  return Theme.Product.initProductThumbSlider(section);
};

/*
 * ProductInfo still needs its async response for price, inventory, SKU and
 * button state. The custom gallery is already updated immediately by this
 * file, so prevent common.js from rebuilding the same gallery a second time
 * when that response arrives.
 */
function installCustomGalleryMediaGuard() {
  const ProductInfoElement = window.customElements?.get('product-info');
  const prototype = ProductInfoElement?.prototype;

  if (!prototype?.updateMedia || prototype.__ttCustomGalleryMediaGuard) return;

  const originalUpdateMedia = prototype.updateMedia;
  prototype.updateMedia = function(parsedHTML, variantFeaturedMediaId) {
    if (this.querySelector?.('[data-tt-product-gallery]')) return;
    return originalUpdateMedia.call(this, parsedHTML, variantFeaturedMediaId);
  };

  Object.defineProperty(prototype, '__ttCustomGalleryMediaGuard', {
    value: true,
    configurable: true
  });
}

installCustomGalleryMediaGuard();
if (!window.customElements?.get('product-info')) {
  window.customElements?.whenDefined('product-info').then(installCustomGalleryMediaGuard);
}

if (document.querySelector('[data-flickity-product-slider]')) {
  window.addEventListener('resize', function() {
    Theme.Product.initProductSlider();
    Theme.Product.initProductThumbSlider();
    if (typeof findVisibleItems === 'function') {
      findVisibleItems();
    }
  });
}

/* TeeTerritory product gallery: color rail + selected-color angle thumbnails. */
(() => {
  let galleryUpdateTimer = null;

  const normalizeValue = value => String(value || '').trim().toLowerCase();

  function getGalleryRoot(element) {
    return element?.closest('[data-tt-product-gallery]') || null;
  }

  function getSectionRoot(gallery) {
    return gallery?.closest('.shopify-section') || document;
  }

  function getSelectedColor(gallery) {
    const section = getSectionRoot(gallery);
    const optionName = gallery.dataset.ttColorOptionName;
    if (!optionName) return '';

    const optionElements = Array.from(
      section.querySelectorAll('variant-selects .productOption')
    ).filter(element => element.name === optionName);

    const selected = optionElements.find(element =>
      element.tagName === 'SELECT' || element.checked
    );

    return normalizeValue(selected?.value);
  }

  function getPreferredMediaId(gallery, selectedColor) {
    const requestedMediaId = gallery.dataset.ttRequestedMediaId;
    if (requestedMediaId) {
      delete gallery.dataset.ttRequestedMediaId;
      return requestedMediaId;
    }

    /*
    * variant-json yalnızca ilk 250 varyantı içerebilir.
    * Soldaki renk alanındaki medya eşlemesi bu sınırdan etkilenmez.
    */
    const colorMediaButton = Array.from(
      gallery.querySelectorAll('[data-tt-color-value]')
    ).find(button =>
      normalizeValue(
        button.dataset.ttColorNormalized || button.dataset.ttColorValue
      ) === selectedColor
    );

    const colorMediaId = colorMediaButton?.dataset.ttMediaId || '';

    if (colorMediaId) {
      return colorMediaId;
    }

    const section = getSectionRoot(gallery);
    const variantJson = section.querySelector('[data-name="variant-json"]');
    if (!variantJson) return '';

    let variants;
    try {
      variants = JSON.parse(variantJson.textContent || '[]');
    } catch (error) {
      console.error('Product variant JSON could not be parsed.', error);
      return '';
    }

    const selectedOptions = Array.from(
      section.querySelectorAll(
        'variant-selects .productOption:checked, variant-selects select.productOption'
      )
    ).map(element => element.value);

    let matchedVariant = variants.find(variant =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    if (!matchedVariant) {
      const optionNumber = Number(
        gallery.dataset.ttColorOptionName?.replace('option-', '')
      );
      const colorIndex = Number.isFinite(optionNumber) ? optionNumber - 1 : 0;

      matchedVariant = variants.find(variant =>
        normalizeValue(variant.options?.[colorIndex]) === selectedColor
      );
    }

    return String(
      matchedVariant?.featured_media?.id ||
      matchedVariant?.featured_image?.id ||
      matchedVariant?.featured_image ||
      ''
    );
  }

  function updateColorRail(gallery, selectedColor) {
    gallery.querySelectorAll('[data-tt-color-value]').forEach(button => {
      const isActive =
        normalizeValue(button.dataset.ttColorNormalized || button.dataset.ttColorValue) ===
        selectedColor;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      if (isActive) {
        const sidebar = button.closest('[data-tt-color-media-sidebar]');
        if (sidebar) {
          const buttonTop = button.offsetTop;
          const buttonBottom = buttonTop + button.offsetHeight;
          const visibleTop = sidebar.scrollTop;
          const visibleBottom = visibleTop + sidebar.clientHeight;

          if (buttonTop < visibleTop) sidebar.scrollTop = buttonTop;
          if (buttonBottom > visibleBottom) {
            sidebar.scrollTop = buttonBottom - sidebar.clientHeight;
          }
        }
      }
    });
  }

  function updateMediaVisibility(gallery, selectedColor) {
    const fancyboxGroup = gallery.dataset.ttFancyboxGroup || 'gallery';

    gallery.querySelectorAll('.tt-main-media, .tt-angle-media').forEach(media => {
      const mediaColor = normalizeValue(media.getAttribute('variant-color'));
      const isVisible = !mediaColor || !selectedColor || mediaColor === selectedColor;

      media.classList.toggle('tt-color-visible', isVisible);
      media.style.display = isVisible ? '' : 'none';

      if (media.classList.contains('tt-main-media')) {
        const zoomLink = media.querySelector('[data-thumb]');
        if (zoomLink) {
          if (isVisible) zoomLink.setAttribute('data-fancybox', fancyboxGroup);
          else zoomLink.removeAttribute('data-fancybox');
        }
      }
    });
  }

  function rebuildGallerySliders(gallery, preferredMainMedia) {
    if (!gallery || typeof Flickity === 'undefined') return;

    const mainSlider = gallery.querySelector('[data-flickity-product-slider]');
    const thumbSlider = gallery.querySelector('[data-flickity-product-thumb-slider]');
    const mainInstance = mainSlider ? Flickity.data(mainSlider) : null;
    const thumbInstance = thumbSlider ? Flickity.data(thumbSlider) : null;

    /*
     * With cellSelector, Flickity keeps excluded color cells outside its
     * internal .flickity-slider element. reloadCells() only inspects the
     * existing internal element, so it cannot pick up the newly selected
     * color. Destroy and initialize synchronously instead. Both operations
     * happen in the same JavaScript task, before the browser can paint the
     * temporary uninitialized markup.
     */
    if (thumbInstance) thumbInstance.destroy();
    if (mainInstance) mainInstance.destroy();

    if (mainSlider) initProductSlider(gallery);
    if (thumbSlider) initProductThumbSlider(gallery);

    const refreshedMain = mainSlider ? Flickity.data(mainSlider) : null;
    const refreshedThumb = thumbSlider ? Flickity.data(thumbSlider) : null;

    if (refreshedMain) {
      const preferredIndex = preferredMainMedia
        ? refreshedMain.cells.findIndex(cell => cell.element === preferredMainMedia)
        : -1;

      refreshedMain.select(preferredIndex > -1 ? preferredIndex : 0, false, true);
      refreshedMain.resize();
    }

    if (refreshedThumb) {
      refreshedThumb.select(0, false, true);
      refreshedThumb.resize();
    }
  }

  function getMediaFilename(media) {
  if (!media) return '';

  const zoomLink = media.querySelector('[data-thumb]');
  const image = media.querySelector('img');

  const source =
    zoomLink?.getAttribute('href') ||
    image?.currentSrc ||
    image?.getAttribute('src') ||
    image?.getAttribute('data-src') ||
    '';

  if (!source) return '';

  try {
    const pathname = new URL(
      source,
      window.location.href
    ).pathname;

    return decodeURIComponent(
      pathname.split('/').pop() || ''
    ).toLowerCase();
  } catch (error) {
    return source
      .split('?')[0]
      .split('/')
      .pop()
      .toLowerCase();
  }
}

function getMediaSource(media) {
  if (!media) return '';

  const zoomLink = media.querySelector('[data-thumb]');
  const image = media.querySelector('img');

  return (
    zoomLink?.getAttribute('href') ||
    image?.currentSrc ||
    image?.getAttribute('src') ||
    image?.getAttribute('data-src') ||
    ''
  );
}

function getMediaFilename(media) {
  const source = getMediaSource(media);

  if (!source) return '';

  try {
    const pathname = new URL(
      source,
      window.location.href
    ).pathname;

    return decodeURIComponent(
      pathname.split('/').pop() || ''
    ).toLowerCase();
  } catch (error) {
    return source
      .split('?')[0]
      .split('/')
      .pop()
      .toLowerCase();
  }
}

function getPreferredVisualMedia(
  gallery,
  targetColor = ''
) {
  const normalizedTargetColor =
    normalizeValue(targetColor);

  const candidateMedia = Array.from(
    gallery.querySelectorAll('.tt-main-media')
  ).filter(media => {
    if (!normalizedTargetColor) {
      return media.classList.contains(
        'tt-color-visible'
      );
    }

    return normalizeValue(
      media.getAttribute('variant-color')
    ) === normalizedTargetColor;
  });

  const hasRole = (media, role) => {
    const filename = getMediaFilename(media);
    const basename = filename.replace(/\.[^.]+$/, '');
    const tokens = basename.split(/[_-]/);

    return tokens.some(token =>
      token === role ||
      (
        role === 'omf' &&
        /^omf\d+$/.test(token)
      )
    );
  };

  // Mankenli ön > düz ön
  return (
    candidateMedia.find(media =>
      hasRole(media, 'omf')
    ) ||
    candidateMedia.find(media =>
      hasRole(media, 'f')
    ) ||
    null
  );
}

function getRailThumbnailUrl(media) {
  const source = getMediaSource(media);

  if (!source) return '';

  try {
    const url = new URL(
      source,
      window.location.href
    );

    url.searchParams.set('width', '120');

    return url.toString();
  } catch (error) {
    return source;
  }
}

function syncColorRailImages(gallery) {
  gallery
    .querySelectorAll('[data-tt-color-value]')
    .forEach(button => {
      const color = normalizeValue(
        button.dataset.ttColorNormalized ||
        button.dataset.ttColorValue
      );

      const preferredMedia =
        getPreferredVisualMedia(gallery, color);

      if (!preferredMedia) return;

      const mediaId = preferredMedia.id.replace(
        'media-main-',
        ''
      );

      const thumbnailUrl =
        getRailThumbnailUrl(preferredMedia);

      if (!mediaId || !thumbnailUrl) return;

      // Sol thumbnail'a basılınca da doğru medya açılsın.
      button.dataset.ttMediaId = mediaId;

      button
        .querySelectorAll('source')
        .forEach(source => {
          source.setAttribute(
            'srcset',
            thumbnailUrl
          );

          source.setAttribute(
            'data-srcset',
            thumbnailUrl
          );
        });

      const thumbnailImage =
        button.querySelector('img');

      if (thumbnailImage) {
        thumbnailImage.setAttribute(
          'src',
          thumbnailUrl
        );

        thumbnailImage.setAttribute(
          'srcset',
          thumbnailUrl
        );

        thumbnailImage.setAttribute(
          'data-src',
          thumbnailUrl
        );

        thumbnailImage.setAttribute(
          'data-srcset',
          thumbnailUrl
        );
      }
    });
}

  function applyGalleryColor(
    gallery,
    selectedColor,
    preferredMediaId = ''
  ) {
    if (!gallery?.isConnected || !selectedColor) {
      return;
    }

    syncColorRailImages(gallery);
    updateColorRail(gallery, selectedColor);
    updateMediaVisibility(gallery, selectedColor);

    const visualPriorityMedia =
      getPreferredVisualMedia(gallery);

    const mappedMainMedia = (
      preferredMediaId
        ? gallery.querySelector(
            '#media-main-' + CSS.escape(preferredMediaId)
          )
        : null
    );

    const preferredMainMedia =
      visualPriorityMedia ||
      mappedMainMedia ||
      gallery.querySelector(
        '.tt-main-media.tt-color-visible.tt-color-primary'
      ) ||
      gallery.querySelector(
        '.tt-main-media.tt-color-visible'
      );

    const currentMainMedia = gallery.querySelector('.tt-main-media.is-selected');
    const sameColor = normalizeValue(gallery.dataset.ttActiveColor) === selectedColor;
    const sameMedia = !preferredMainMedia || currentMainMedia === preferredMainMedia;

    // Ignore duplicate change/pageshow callbacks for the same selection.
    if (sameColor && sameMedia) return;

    rebuildGallerySliders(gallery, preferredMainMedia);
    gallery.dataset.ttActiveColor = selectedColor;
  }

  function updateGallery(gallery) {
    if (!gallery?.isConnected) return;

    const selectedColor = getSelectedColor(gallery);
    if (!selectedColor) return;

    const preferredMediaId = getPreferredMediaId(gallery, selectedColor);
    applyGalleryColor(gallery, selectedColor, preferredMediaId);
  }

  function updateAllGalleries() {
    document.querySelectorAll('[data-tt-product-gallery]').forEach(updateGallery);
  }

  function scheduleGalleryUpdate(delay = 80) {
    window.clearTimeout(galleryUpdateTimer);
    galleryUpdateTimer = window.setTimeout(updateAllGalleries, delay);
  }

  document.addEventListener('click', event => {
    const colorButton = event.target.closest('[data-tt-color-value]');
    if (colorButton) {
      event.preventDefault();

      const gallery = getGalleryRoot(colorButton);
      const section = getSectionRoot(gallery);
      const optionName = gallery.dataset.ttColorOptionName;
      const requestedColor = normalizeValue(colorButton.dataset.ttColorValue);

      const matchingOption = Array.from(
        section.querySelectorAll('variant-selects .productOption')
      ).find(element =>
        element.name === optionName && normalizeValue(element.value) === requestedColor
      );

      if (matchingOption?.tagName === 'SELECT') {
        matchingOption.value = colorButton.dataset.ttColorValue;
        matchingOption.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (matchingOption) {
        if (!matchingOption.checked) matchingOption.click();
        else scheduleGalleryUpdate(0);
      }

      /*
       * Read the exact variant only after its color input has been selected.
       * Using the rail button's media id here briefly selected a back/profile
       * image before the exact variant's front image was known.
       */
      delete gallery.dataset.ttRequestedMediaId;
      const preferredMediaId = matchingOption
        ? getPreferredMediaId(gallery, requestedColor)
        : colorButton.dataset.ttMediaId || '';
      applyGalleryColor(gallery, requestedColor, preferredMediaId);

      return;
    }

    const thumb = event.target.closest('.tt-angle-media[id^="media-thumb-"]');
    if (!thumb) return;

    const gallery = getGalleryRoot(thumb);
    const mediaId = thumb.id.replace('media-thumb-', '');
    const targetSlide = gallery.querySelector('#media-main-' + CSS.escape(mediaId));
    const mainSlider = gallery.querySelector('[data-flickity-product-slider]');
    const instance = mainSlider ? Flickity.data(mainSlider) : null;

    if (instance && targetSlide) {
      const slideIndex = instance.cells.findIndex(cell => cell.element === targetSlide);
      if (slideIndex > -1) instance.select(slideIndex, false, true);
    }
  });

  document.addEventListener('change', event => {
    if (!event.target.closest('variant-selects')) return;
    if (!event.target.matches('input.productOption, select.productOption')) return;
    if (event.target.closest('.quality_input')) return;

    scheduleGalleryUpdate();
  });

  const galleryObserver = new MutationObserver(mutations => {
    const galleryMarkupAdded = mutations.some(mutation =>
      Array.from(mutation.addedNodes).some(node =>
        node instanceof Element &&
        (
          node.matches('[data-tt-product-gallery], [data-product-slider-main-wrapper]') ||
          node.querySelector('[data-tt-product-gallery], [data-product-slider-main-wrapper]')
        )
      )
    );

    if (galleryMarkupAdded) scheduleGalleryUpdate(0);
  });

  galleryObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', () => scheduleGalleryUpdate(0));
  document.addEventListener('shopify:section:load', () => scheduleGalleryUpdate(0));
  window.addEventListener('pageshow', () => scheduleGalleryUpdate(0));
})();
